import React from 'react';

function LoadingData() {
  return <div className="loader">Loading ...</div>;
}

export default LoadingData;
